import { useContext, useMemo } from 'react';
/**
 * Below follows the trick to allow useId to get ssr-safe ids
 * when apps have wrapped their tree with `SSRProvider`.
 *
 * It's a try-require trick.
 *
 * If react-accessibility-provider is installed by the app,
 * IdContext module is loaded from there.
 * This guarantees that the instance of IdContext will always be the same
 * This guarantees the deterministic sequential orders of autogenerated ids in the app tree
 * npm dedupe bedamned
 *
 * If app is not using react-accessibility-provider,
 * IdContext is loaded from this package's dependency.
 * In that case, autogenerated-ids are random (`uuid`-based)
 * Functionality still works regardless of duplicates in the tree
 * npm dedupe bedamned
 * Note that client hydration will fail because the IDs are random.
 * Apps should ensure that react-accessibility-provider
 * is installed and used so that deterministic IDs can be used.
 */

var IdContextModule;

try {
  // has app installed accessibility-provider as a peer dependency?
  var moduleId = require.resolve('@nerdwallet/react-accessibility-provider/IdContext'); // Yes; load IdContext from its dependencies.
  // In Node, `moduleId` will be the path to the module.
  // In Webpack, `moduleId` will be the ID of the module in Webpack's
  // module cache.


  IdContextModule = require(moduleId); // eslint-disable-line global-require,import/no-dynamic-require
} catch (error) {
  if (error.code !== 'MODULE_NOT_FOUND') {
    throw error;
  } // fallback to the IdContext from this package's dependency


  IdContextModule = require('@nerdwallet/react-accessibility-id-context'); // eslint-disable-line global-require
}

var _IdContextModule = IdContextModule,
    IdContext = _IdContextModule["default"],
    DEFAULT_ID_CONTEXT = _IdContextModule.defaultContext;
/**
 * If a default is not provided, generate an id.
 * This is SSR safe (deterministic id, consistent between server and client)
 * @param defaultId - Default component id.
 */

export default function useId(defaultId) {
  var generateId = useContext(IdContext);

  if (!defaultId && generateId === DEFAULT_ID_CONTEXT) {
    if (process.env.NODE_ENV !== 'production') {
      // define the string literal inside the NODE_ENV production guard
      // so that it doesn't get bundled into production apps
      var SSR_PROVIDER_NOT_FOUND_WARNING_MESSAGE = "\n@nerdwallet/react-accessibility-provider SSRProvider must wrap your application tree for successful SSR render.\n\nThis warning will occur until the following happens:\n  - install @nerdwallet/react-accessibility-provider in your app\n  - update nw-app-* modules\n    - nw-app-build >=5.31.0\n    - nw-app-module >=13.32.0\n\n```\n  npm install @nerdwallet/react-accessibility-provider@latest @nerdwallet/nw-app-build@latest @nerdwallet/nw-app-module@latest\n```\n      ";
      console.warn(SSR_PROVIDER_NOT_FOUND_WARNING_MESSAGE); // eslint-disable-line no-console
    }
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  return useMemo(function () {
    return defaultId || generateId();
  }, [defaultId]);
}